import { render } from "./ThePurchaseAuthorizationCreate.vue?vue&type=template&id=658976aa&scoped=true&ts=true"
import script from "./ThePurchaseAuthorizationCreate.vue?vue&type=script&lang=ts"
export * from "./ThePurchaseAuthorizationCreate.vue?vue&type=script&lang=ts"

import "./ThePurchaseAuthorizationCreate.vue?vue&type=style&index=0&id=658976aa&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658976aa"]])

export default __exports__